import { render } from "./ManagementDashboard.vue?vue&type=template&id=fa1497be&scoped=true"
import script from "./ManagementDashboard.vue?vue&type=script&lang=js"
export * from "./ManagementDashboard.vue?vue&type=script&lang=js"

import "./ManagementDashboard.vue?vue&type=style&index=0&id=fa1497be&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa1497be"]])

export default __exports__